__turbopack_context__.v({
  "logo": "Ty73YW_logo",
  "popup": "Ty73YW_popup",
});
